import React from 'react';
import { useTranslation } from 'react-i18next';
import { truncateNumberWithPrecision } from 'src/common/helpers/number-helper';
import { ITareWeight } from '../../common/interfaces/dtos/ITareWeight';
import ActionWindowLinkedLine from './linked-line';

const ActionWindowManualTareLine: React.FC<Props> = (props: Props): JSX.Element => {
  const { tareWeight, atomicMsuUnit } = props;
  const { t } = useTranslation();
  let tareText: string = '';

  if (tareWeight?.IsManualFixedTare || tareWeight?.IsManualPercentage) {
    const manualText: string = t('ManualTare');
    const safeTareValue = tareWeight?.TareValue || 0;
    let tare: string = '';
    if (tareWeight.IsManualPercentage) {
      const safeGrossWeight = tareWeight?.GrossWeight || 0;
      tare = truncateNumberWithPrecision((safeGrossWeight / 100) * safeTareValue, false);
    } else {
      tare = truncateNumberWithPrecision(safeTareValue, false);
    }
    tareText = `${tare} ${atomicMsuUnit?.toLowerCase()} ${manualText}`;
  } else {
    tareText = `${t('TareWeight_None')}`;
  }

  return <ActionWindowLinkedLine linkedLineText={tareText} />;
};

interface Props {
  tareWeight: ITareWeight | undefined;
  atomicMsuUnit: string | undefined;
}

export default ActionWindowManualTareLine;
